export default __webpack_public_path__ + "static/media/rightimg.f73e82c3.svg";